import styled from 'styled-components'

import CPickCCI from './PickCCI'
import CLogin from './Login'
import CTwoFactorAuth from './TwoFactorAuth'

export const Container = styled.div<{ $background: string }>`
  background-image: url(${(props) => props.$background});
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 1.6rem;
`

export const PickCCI = styled(CPickCCI)``

export const Login = styled(CLogin)``

export const TwoFactorAuth = styled(CTwoFactorAuth)``
